import { render, staticRenderFns } from "./BOT.vue?vue&type=template&id=21e96cfc&scoped=true&"
import script from "./BOT.vue?vue&type=script&lang=ts&"
export * from "./BOT.vue?vue&type=script&lang=ts&"
import style0 from "./BOT.vue?vue&type=style&index=0&id=21e96cfc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e96cfc",
  null
  
)

export default component.exports